'use client';

import { c as _c } from "react/compiler-runtime";
import { useWebHaptics } from 'web-haptics/react';
import { categoryConfig } from '@/data/closet';
interface CategoryFilterProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  onCategoryHover?: (category: string | null) => void;
}
export function CategoryFilter(t0) {
  const $ = _c(16);
  const {
    selectedCategory,
    onCategoryChange,
    onCategoryHover
  } = t0;
  const haptic = useWebHaptics();
  let t1;
  if ($[0] !== haptic || $[1] !== onCategoryChange || $[2] !== onCategoryHover || $[3] !== selectedCategory) {
    const categories = Object.entries(categoryConfig).filter(_temp).sort(_temp2);
    let t2;
    if ($[5] !== haptic || $[6] !== onCategoryChange) {
      t2 = () => {
        haptic.trigger("selection");
        onCategoryChange("all");
      };
      $[5] = haptic;
      $[6] = onCategoryChange;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    let t4;
    if ($[8] !== onCategoryHover) {
      t3 = () => onCategoryHover?.(null);
      t4 = () => onCategoryHover?.(null);
      $[8] = onCategoryHover;
      $[9] = t3;
      $[10] = t4;
    } else {
      t3 = $[9];
      t4 = $[10];
    }
    const t5 = `text-xs transition-opacity ${selectedCategory === "all" ? "opacity-100" : "opacity-40 hover:opacity-60"}`;
    let t6;
    if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
      t6 = <button type="button" onClick={t2} onMouseEnter={t3} onMouseLeave={t4} aria-label="Filter by all items" className={t5}>ALL ITEMS</button>;
      $[11] = t2;
      $[12] = t3;
      $[13] = t4;
      $[14] = t5;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t1 = <div className="scrollbar-hide flex items-center gap-4 overflow-x-auto whitespace-nowrap md:gap-3">{t6}{categories.map(t7 => {
        const [key_0, config] = t7;
        return <button key={key_0} type="button" onClick={() => {
          haptic.trigger("selection");
          onCategoryChange(key_0);
        }} onMouseEnter={() => onCategoryHover?.(key_0)} onMouseLeave={() => onCategoryHover?.(null)} aria-label={`Filter by ${config.label}`} className={`text-xs transition-opacity ${selectedCategory === key_0 ? "opacity-100" : "opacity-40 hover:opacity-60"}`}>{config.label.toUpperCase()}</button>;
      })}</div>;
    $[0] = haptic;
    $[1] = onCategoryChange;
    $[2] = onCategoryHover;
    $[3] = selectedCategory;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function _temp2(a, b) {
  return a[1].order - b[1].order;
}
function _temp(t0) {
  const [key] = t0;
  return key !== "underwear" && key !== "fullbody" && key !== "fragrances";
}